// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_NZC","cls2":"ReferenceCard-cls2_u1M ReferenceCard-cls1_NZC","shimmer":"ReferenceCard-shimmer_gpn"};